<template>
	<div>
		<button v-on:click="startScanning"
				:class="barcode ? 'grey-background' : ''"
				class="better-mobile-btn">
			<i class="fas fa-qrcode"></i>
			{{ barcode ? "Re-Scan Decal" : "Scan Decal"}}
		</button>

		<div v-if="isScanning" class="fullscreen-overlay">
			<h2 class="overlay-header">{{ user_name }}</h2>

			<div class="overlay-body">
				<h5 class="p-05">{{ credential_title }}</h5>

				<div class="camera-container">
					<qrcode-stream
						v-if="awaitingScan"
						@init="onInit"
						class="mb-3"
						@decode="onCodeScanned"
						style="text-align:center;">
						<loading-dots v-if="isLoading"/>
					</qrcode-stream>
				</div>

				<div class="barcode-container">
					<div>
						<input
							type="text"
							placeholder="Barcode"
							class="barcode-field"
							v-model="barcode"
							v-on:input="onManualEntry"
						/>
					</div>

					<div class="button-row">
						<button
							:disabled="awaitingScan"
							class="better-mobile-btn"
							v-on:click="complete">
							{{ awaitingScan ? "Scan Decal" : "Decal Given to Patron"}}
						</button>
					</div>
				</div>

				<div class="p-1">
					<button class="better-mobile-btn red" v-on:click="resetState">Back</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {QrcodeStream} from "vue-qrcode-reader";
import LoadingDots from "./icons_svg/LoadingDots.vue";

export default {
	name: 'ScanQrButtonV2',
	components: {
		QrcodeStream,
		LoadingDots,
	},
	props: {
		user_name: {
			type: String,
			required: true
		},
		credential_title: {
			type: String,
			required: true
		},
		initial_value: {
			type: String,
			default: ""
		},
	},
	data() {
		return {
			isLoading: false,
			isScanning: false,
			awaitingScan: false,
			barcode: this.initial_value
		}
	},
	methods: {
		async onInit(promise) {
			this.isLoading = true;
			try {
				await promise
			} catch (error) {
				alert(error)
			} finally {
				this.isLoading = false
			}
		},
		// Called when a qr code is read correctly
		onCodeScanned(barcode) {
			this.barcode = barcode
			this.awaitingScan = !(barcode && barcode.length >= 8);
		},
		onManualEntry() {
			this.onCodeScanned(this.barcode)
		},
		async startScanning() {
			this.isScanning = true
			this.awaitingScan = true
		},
		complete() {
			this.$emit('onScannedQr', this.barcode)
			this.resetState()
		},
		resetState() {
			this.isScanning = false
			this.barcode = ""
			this.awaitingScan = false
		},
	},
}
</script>

<style scoped>
.camera-container {
	max-height: 30em;
	max-width: 20em;
	margin: 0 auto;
}

.barcode-container {
	width: 100%;
	max-width: 20em;
	margin: 0 auto;
}

.barcode-field {
	width: 100%;
	margin: 0;
}

.grey-background {
	background: #666 !important;
}
</style>